import { DebitCardTransactionType, ForeignCurrencyType } from './DebitCardDomain'

export const MAX_ACCOUNT_COUNT = 20

export const QUICK_CREDIT_STATUS_CODE = {
  NORMAL: '01',
  OVERDUE: '02',
  EXPIRED: '03',
  TERMINATED: '04',
}
export interface IQuickCreditParams {
  qcExistYn: boolean // Quick Credit(대출 계좌) 연동 고객 여부
  creditJan: string // 대출 계좌 잔고
  overdueYn: boolean // 대출 연체 여부
  qcStatusTypeCode: typeof QUICK_CREDIT_STATUS_CODE[keyof typeof QUICK_CREDIT_STATUS_CODE] // 대출 계좌 상태
}

export interface ISimpleAccountResponse {
  acctColor: string // 색상코드
  acctNo: string // 계좌번호
  acctTitle: string // 계좌이름
  baseAcctCcy: string // 계좌통화코드
  baseCurJan: string // 지금가능금액
  debitCardYn: boolean // debit발급여부
  dpAcctYn: boolean // 대표계좌여부
  payYn: boolean // 지급가능여부
  subjCd: string // 상품유형코드

  loanLinkYn: boolean // 론링크여부
  creditJan: string // 대출가능잔액
  lonAcctNo: string // 대출계좌번호
}

export interface ISimpleAccountList extends IQuickCreditParams {
  list: ISimpleAccountResponse[]
}

export const EmptySimpleAccount: ISimpleAccountResponse = {
  acctColor: '',
  acctNo: '',
  acctTitle: '',
  baseAcctCcy: '',
  baseCurJan: '',
  dpAcctYn: false,
  subjCd: '',
  debitCardYn: false,
  payYn: false,

  loanLinkYn: false,
  creditJan: '0',
  lonAcctNo: '',
}
export interface IAccountDetail {
  description: string
}

export interface IAccount {
  acctCcy: string
  acctColor: number
  acctNo: string
  acctPrdNm: string
  acctTitle: string
  bsJan: string
  cbsObbAmt: string
  contStsNm: string
  curJan: string
  custNm: string
  detail: {} | IAccountDetail
  dpAcctYn: boolean
  dptBasicRt: string
  isDebitCardIssued: boolean
  openDtm: number
  sbjNm: string
  stopAmt: string
  subjCd: string
}

export interface IAccountCountResponse {
  acctNo: string // 최종계좌번호
  totAcct: number // 전체 계좌 갯수
  totGroup: number // Group Account 갯수
  totSaving: number // 입출금계좌 갯수
}

export const EmptyAccount: IAccount = {
  acctCcy: 'IDR', // 계좌통화코드
  acctColor: 11, // 색상코드
  acctNo: '9010300001001231000', // 계좌번호
  acctPrdNm: 'HANA current', // 상품이름
  acctTitle: 'My Current', // 거래계좌별칭
  bsJan: '30000', // 원장잔액
  cbsObbAmt: '100', // 미결제타점권금액
  contStsNm: 'Active', // 계좌상태
  curJan: '9000', // 지급가능잔액
  custNm: 'SHIN MINA', // 계좌주이름
  detail: {},
  dpAcctYn: false, // 대표계좌여부
  dptBasicRt: '5.5', // 이자율
  isDebitCardIssued: false, // Debit Card 발급 여부
  openDtm: 1353772991057, // 개설일
  sbjNm: 'TIME DEPOSIT', // 계좌유형이름
  stopAmt: '100', // 동결금액
  subjCd: '11', // 상품유형코드
}

export const EmptyAccountCountResponse: IAccountCountResponse = {
  acctNo: '',
  totAcct: 0,
  totGroup: 0,
  totSaving: 0,
}

export interface IAccountTransactionDetail {
  acctNo: string // 거래 기준 계좌번호
  acctTitle: string // 거래 기준 계좌 별칭
  afInt: string // Interest after tax (or 연체이자)
  bfInt: string // Interest after tax (or 납기내 이자)
  bnftFee: string // 혜택 받은 수수료
  endDtm: string // 종료일자
  principal: string // 원금
  rcvLineId: string // 수취인 Line ID (내부용)
  rcvPhoneNo: string // 수취인 Phone Number
  startDtm: string // 시작일자
  tranFeeAmt: string // 거래수수료
  trxAcctNm: string // 거래계좌주이름
  trxAcctNo: string // 거래계좌번호
  trxAcctTitle: string // 거래라인계좌 별칭
  trxApprDtm: number // 거래취소의 거래승인일시
  trxBnkCd: string // 거래은행코드
  trxBnkNm: string // 거래은행이름
  trxGbCd: string // 거래구분코드. 51 : Transfer, 61 : Schedule Transfer, 71 : Debit Card, 72 : Debit Card Canceled, 41 : ATM, 81 : Bill Payment, 12 : Deposit, 21 : Term Account, 31 : Quick Credit, 33 : Quick Cash
  trxMedNo: string // 거래 직불카드 번호
  trxMerchantNm: string // 가맹점 이름
  trxOriAmt: string // 거래 직불카드 번호
  trxOriCcy: ForeignCurrencyType // 직불카드 해외 통화코드
}

export interface IAccountTransaction {
  acctTitle: string // 거래계좌벼칭
  detail: IAccountTransactionDetail
  expDtm: string // 정기예금 만기일자
  hisNo: string // 거래이력번호
  ibjiGb: string // 입금지출 구분코드 (D or W)
  intRt: string // 정기예금 약정 이자율
  refNo: string // 거래참조번호
  term: string // 정기예금 계약기간(월단위)
  tranAfJan: string // 거래후잔액
  tranRemark: string // 적요
  tranTrAmt: string //  거래금액
  tranTrCd: DebitCardTransactionType // 거래유형 거래코드표 참조
  tranTrDtm: number // 거래시간
  trxGbCd: string // 세부거래유형 (51 : Transfer, 61 : Schedule Transfer, 71 : Debit Card, 72 : Debit Card Canceled 41 : ATM, 81 : Bill Payment, 12 : Deposit, 21 : Term Account)
  trxNote: string // 노트
  trxTitle: string // 거래명칭 (거래유형에 따라 받는사람이름, 보낸사람이름, 계좌별칭 등 이 됨)
}

export const EmptyAccountTransactionDetail = {
  acctNo: '',
  acctTitle: '',
  afInt: '',
  bfInt: '',
  bnftFee: '0.00',
  endDtm: '',
  principal: '',
  rcvLineId: '',
  rcvPhoneNo: '',
  startDtm: '',
  tranFeeAmt: '',
  trxAcctNm: '',
  trxAcctNo: '',
  trxAcctTitle: '',
  trxApprDtm: 0,
  trxBnkCd: '',
  trxBnkNm: '',
  trxGbCd: '',
  trxMedNo: '',
  trxMerchantNm: '',
  trxOriAmt: '',
  trxOriCcy: ForeignCurrencyType.USD,
}

export const EmptyAccountTransaction = {
  acctTitle: '',
  detail: EmptyAccountTransactionDetail,
  expDtm: '',
  hisNo: '',
  ibjiGb: '',
  intRt: '',
  refNo: '',
  term: '',
  tranAfJan: '',
  tranRemark: '',
  tranTrAmt: '',
  tranTrCd: DebitCardTransactionType.ATM_DEPOSIT,
  tranTrDtm: 0,
  trxGbCd: '',
  trxNote: '',
  trxTitle: '',
}
